import PreviewTable from '../../../components/Dataset/PreviewTable';
import FrequencyPreviewTable from '../../../components/Dataset/FrequencyPreviewTable';
import React from 'react';
import PropTypes from 'prop-types';
import withToolsetPlaceholder from 'components/ToolsetPlaceholder';

const SelectedDatasetPreview = props => {
  const { isFrequencyTable, isContingencyTable, parameters } = props;
  if (parameters) {
    if (isFrequencyTable || isContingencyTable) {
      return (
        <FrequencyPreviewTable {...props} />
      );
    }
    return (
      <PreviewTable />
    );
  } else {
    return null;
  }

};

SelectedDatasetPreview.propTypes = {
  parameters: PropTypes.object,
  isFrequencyTable: PropTypes.bool.isRequired,
  isContingencyTable: PropTypes.bool.isRequired
};

export default withToolsetPlaceholder(SelectedDatasetPreview);
